export enum QueryKey {
  AUTO_AUTHENTICATE_SESSION = 'AUTO_AUTHENTICATE_SESSION',
}
